import { PageHeader } from "@/components/common/PageHeader";
import { Card } from "@/components/ui/card";
import { ImportWizard } from "@/components/common/ImportWizard";

export default function Importa() {
  return (
    <div>
      <PageHeader title="Importa da altro gestionale" subtitle="Migra clienti e storico vendite da CSV/XLSX (Fresha e altri gestionali)" />
      <Card className="p-5 max-w-3xl" data-testid="import-page">
        <ImportWizard defaultEntity="clients" allowEntitySwitch onDone={() => {}} />
      </Card>
    </div>
  );
}
